import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Card,
  CardContent,
  Grid,
  CardHeader,
  Typography,
  CircularProgress,
  Button,
  InputLabel,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { MartReportService } from "../../services/MartReportService";
import DataTable from "react-data-table-component";
import CsvDownload from "react-json-to-csv";
import MonthSelector from "../elements/MonthSelector";
import months from "../elements/MonthSelector";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import SalesReportsTable from "../pharmacy/reports/SalesReportsTable";

const useStyles = makeStyles((theme) => ({}));
const date = new Date();
const currentDate = {
  name: moment(date).format("MMMM"),
  id: date.getMonth() + 1,
  year: date.getFullYear(),
};
const SalesReports = () => {
  const classes = useStyles();
  const startOfMonth = moment().startOf("month").format("MMMM DD YYYY");
  const currentOfMonth = moment().format("MMMM DD YYYY");
  const [reports, setReports] = useState([]);
  const [csv, setCSV] = useState([]);
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState(currentDate);
  const [startDate, setStartDate] = useState(null);
  const [lastDate, setLastDate] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedDate, setSelectedDate] = React.useState(date);

  useEffect(() => {
    setStartDate(moment(selectedDate).startOf("month").format("MMMM DD YYYY"));
    setLastDate(moment(selectedDate).endOf("month").format("MMMM DD YYYY"));
    setLoading(true);
    setMonth({
      name: moment(selectedDate).format("MMMM"),
      id: selectedDate.getMonth() + 1,
      year: selectedDate.getFullYear(),
    });
  }, [selectedDate]);

  useEffect(() => {
    MartReportService.getMonthlyReportsByYear(month.id, month.year)
      .then((res) => {
        setLoading(false);
        setReports(res.response);
        let mCSV = res.response.map((r, index) => ({
          "Sr.#": index == res.response.length - 1 ? "" : index + 1,
          Day: r.day,
          Discount: r.totalDiscount,
          SaleAmount: r.total,
          Cost: r.cost,
          Profit: r.profit,
          DeliveryCharges: r.deliveryCharges,
          "%": r.percent,
        }));
        setCSV(mCSV);
      })
      .catch((error) => {
        setLoading(false);
        setMessage("Something went wrong cant load reports. Try again!.");
      });
  }, [month]);

  return (
    <Card>
      <CardHeader
        title="Grocery wise sales report"
        subheader={
          moment().format("MMMM") !== month.name
            ? `From ${startDate} To ${lastDate}`
            : `From ${startOfMonth} To ${currentOfMonth}`
        }
        action={
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="space-around">
              <DatePicker
                variant="inline"
                openTo="month"
                views={["year", "month"]}
                label="Year and Month"
                helperText="Start from month selection"
                value={selectedDate}
                onChange={(date) => setSelectedDate(date)}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        }
      />
      <CardContent>
        <SalesReportsTable
          loading={loading}
          reports={reports}
          csv={csv}
          message={message}
        />
      </CardContent>
    </Card>
  );
};

export default SalesReports;
